import React, { useEffect, useState } from 'react'
import { startUpload } from '../hooks/uploadFile'
import { styled } from '@mui/material/styles';

import { Link, Container, Typography, Divider, Stack, Button, TextField, Checkbox, LinearProgress, Box, Autocomplete, Chip, Alert, Backdrop, CircularProgress } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import Swal from 'sweetalert2'
import { useNavigate, useParams } from 'react-router-dom'


import { Uppy } from '@uppy/core';
import { DragDrop, StatusBar } from '@uppy/react';
import Transloadit from '@uppy/transloadit';
import ThumbnailGenerator from '@uppy/thumbnail-generator';
import Tus from '@uppy/tus';
import { formatBytes } from '../utils/formatNumber'
import AwsS3 from "@uppy/aws-s3";
//styles scss
import styles from "../styles/documentsPage.module.scss";

import '@uppy/core/dist/style.min.css';
import '@uppy/drag-drop/dist/style.min.css';
import '@uppy/status-bar/dist/style.min.css';
import { useDispatch, useSelector } from 'react-redux';


const StyledRoot = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex',
    },
}));

const StyledSection = styled('div')(({ theme }) => ({
    width: '100%',
    maxWidth: 480,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    boxShadow: theme.customShadows.card,
    backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));




const createUppy = (callback) => {
    // Adding to global `meta` will add it to every file.
    // Every Uppy instance needs a unique ID.
    const uppy = new Uppy({ allowMultipleUploads: false })
    uppy.use(ThumbnailGenerator).use(AwsS3, {
        fields: [], // empty array 
        getUploadParameters(file) { // here we prepare our request to the server for the upload URL
            return fetch(`${process.env.REACT_APP_LOCAL_API_URL}/upload-document`, { // we'll send the info asynchronously via fetch to our nodejs server endpoint, '/uploader' in this case
                method: 'POST', // all the examples I found via the Uppy site used 'PUT' and did not work
                headers: {
                    // 'content-type': 'application/x-www-form-urlencoded', 
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    "document_name": file.name,
                    "document_type": file.type
                })
            }).then((response) => {
                return response.json(); // return the server's response as a JSON promise
            }).then((data) => {
                console.log('>>>', data); // here you can have a look at the data the server sent back - get rid of this for production!
                return {
                    method: data.method, // here we send method, url, fields and headers to the AWS S3 bucket
                    url: data.url,
                    fields: data.fields,
                    headers: data.headers,
                };
            });
        },
    });
    return uppy
}

const EditDocumentForm = () => {
    const signinSliceData = useSelector((state) => state.Signin.data);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    const [folders, setFolders] = useState([])
    const [foldersOptions, setFoldersOptions] = useState([]);
    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [tags, setTags] = useState([])
    const [tagsOptions, setTagsOptions] = useState([])
    const [documentPath, setDocumentPath] = useState("");
    const [documentURL, setDocumentURL] = useState("")



    const [documentMetaName, setDocumentMetaName] = useState("");
    const [documentMetaType, setDocumentMetaType] = useState("");
    const [documentMetaSize, setDocumentMetaSize] = useState(0);
    const [loading, setLoading] = useState(false);



    const selectDocumentPath = (documentPath) => {
        setDocumentPath(documentPath)
    }

    const [uppy, setUppy] = useState(() => createUppy(selectDocumentPath));



    const [selecteFileDetails, setSelecteFileDetails] = useState({});
    const [fileUploadedSuccess, setFileUploadedSuccess] = useState({});

    const handleLogout = async () => {
        dispatch({
            type: 'SIGN_OUT',
            payload: {},
        });
        navigate('/');
    };


    const fetchTagsOptions = async (search) => {
        const options = {
            headers: {
                "Content-Type": "application/json",
                authorization: `${signinSliceData.access_token}`,
            },
        }
        if (search && search.length) {
            let response = await fetch(`${process.env.REACT_APP_LOCAL_API_URL}/tags?search_string=` + search, options)
            if (response.status == 200) {
                let respData = await response.json()
                setTagsOptions(respData.data.map((e) => e.tag))
            }
        }
        else {
            setTagsOptions([])
        }
    }


    const checkDisable = () => {

        if (documentPath.length || documentURL.length) {
            return !title.length || !tags.length
        }
        else {
            return true
        }
    }


    const fetchFoldersOptions = async (search) => {
        const options = {
            headers: {
                "Content-Type": "application/json",
                authorization: `${signinSliceData.access_token}`,
            },
        }
        if (search && search.length) {
            let response = await fetch(`${process.env.REACT_APP_LOCAL_API_URL}/folders?search_string=` + search, options)
            if (response.status == 200) {
                let respData = await response.json()
                setFoldersOptions(respData.data.map((e) => e.folder))
            }
        }
        else {
            setFoldersOptions([])
        }
    }

    useEffect(() => {
        const uppy = new Uppy({})
        uppy.use(ThumbnailGenerator).use(AwsS3, {
            fields: [], // empty array 
            getUploadParameters(file) { // here we prepare our request to the server for the upload URL
                return fetch(`${process.env.REACT_APP_LOCAL_API_URL}/upload-document`, { // we'll send the info asynchronously via fetch to our nodejs server endpoint, '/uploader' in this case
                    method: 'POST', // all the examples I found via the Uppy site used 'PUT' and did not work
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `${signinSliceData.access_token}`,
                    },
                    body: JSON.stringify({
                        "document_name": file.name,
                        "document_type": file.type
                    })
                }).then((response) => {
                    return response.json(); // return the server's response as a JSON promise
                }).then((data) => {
                    console.log('>>>', data); // here you can have a look at the data the server sent back - get rid of this for production

                    setDocumentPath(data.data.file_path)
                    return {
                        method: 'PUT', // here we send method, url, fields and headers to the AWS S3 bucket
                        url: data.data.signed_url
                    };
                });
            },
        });
        setUppy(uppy)
    }, [])

    uppy.on('file-added', (file) => {
        setSelecteFileDetails(file)
    });
    uppy.on('upload-success', (file) => {
        setFileUploadedSuccess(file.data)
        setTitle(file.data.name)

        setDocumentMetaName(file.data.name)
        setDocumentMetaSize(file.data.size)
        setDocumentMetaType(file.data.type)
    });

    uppy.on('thumbnail:generated', (file, preview) => {
        console.log(file, preview)
    })

    const setDocumentData = (data) => {
        setTitle(data.title)
        setDescription(data.description)
        setTags(data.tags)
        setFolders(data.folders)
        setDocumentPath(data.document_path)
        setDocumentURL(data.document_url)

        const metaData = {
            name: data.document_meta_name,
            type: data.document_meta_type,
            size: data.document_meta_size,
        }
        setSelecteFileDetails(metaData)
        setFileUploadedSuccess(metaData)

        setDocumentMetaName(metaData.name)
        setDocumentMetaSize(metaData.size)
        setDocumentMetaType(metaData.type)

    }

    useEffect(() => {
        fetchDocument()
    }, [])
    const fetchDocument = async () => {
        try {

            setLoading(true)
            const options = {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${signinSliceData.access_token}`,
                },
            }

            let response = await fetch(`${process.env.REACT_APP_LOCAL_API_URL}/documents/` + params.id,
                options)

            if (response.status == 200) {
                let respData = await response.json()


                if (respData.success) {
                    setDocumentData(respData.data)

                }
            } else {
                setDocumentData({})
            }
            if (response.status === 401) {
                handleLogout();
            }
        }
        catch (err) {
            console.log(err)
            setDocumentData({})
        }
        finally {
            setLoading(false)
        }
    }

    const submitUpdateDocument = async () => {

        setLoading(true)
        try {

            const data = {
                title: title,
                description: description,
                tags: tags,
                folders: folders,
                document_meta_name: documentMetaName,
                document_meta_type: documentMetaType,
                document_meta_size: documentMetaSize,
                document_path: documentPath,
                document_url: documentURL,

            }
            const options = {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${signinSliceData.access_token}`,
                },
                body: JSON.stringify(data)
            }

            let response = await fetch(`${process.env.REACT_APP_LOCAL_API_URL}/documents/` + params.id,
                options)
            if (response.status == 200) {
                const respData = await response.json()
                if (respData.success) {
                    Swal.fire({
                        title: 'Success!',
                        text: 'Document Updated Successfully',
                        icon: 'success',
                        confirmButtonText: 'Ok',
                        didClose: () => {
                            navigate('/dashboard/documents')
                        }
                    })
                }
                else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Something went wrong !',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: 'Something went wrong !',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
            }


        }
        catch (err) {

            console.log(err)
            Swal.fire({
                title: 'Error!',
                text: 'Do you want to continue',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }
        finally {
            setLoading(false)
        }

    }


    useEffect(() => {
    }, [])





    const removeFile = (e) => {
        uppy.removeFile(selecteFileDetails.id)
        setSelecteFileDetails({})
    }


    return (
        <Container maxWidth="xl">


            {uppy && <Stack spacing={3}>
                {/* <DragDrop uppy={uppy} />
                <StatusBar uppy={uppy} /> */}


                {!documentPath && selecteFileDetails && selecteFileDetails.name && <span>

                    <span>
                        <img alt={title} width="30" src="/assets/icons/ic_document.svg" />
                        {
                            selecteFileDetails ? selecteFileDetails.name : ""}
                    </span>

                </span>}

                {documentPath && fileUploadedSuccess &&
                    <div>

                        <p>
                            <span style={{ marginLeft: "30px" }}> {fileUploadedSuccess.name}</span>
                            <span style={{ alignContent: "right", marginLeft: "50px" }}> {formatBytes(fileUploadedSuccess.size)}</span>
                        </p>
                    </div>}

            </Stack>}

            <Stack spacing={5} mb={2}>
                <TextField multiline
                    maxRows={4} minRows={2}
                    name="document url" label="Document URL"
                    value={documentURL}
                    onChange={(event) => {
                        setDocumentURL(event.target.value);
                    }}
                />
            </Stack>

            <Stack spacing={3}>
                <TextField name="title"
                    value={title}
                    onChange={(event) => {
                        setTitle(event.target.value);
                    }}
                    label="Title" />

                <TextField multiline
                    value={description}
                    maxRows={4} minRows={2}
                    name="description" label="Description"
                    onChange={(event) => {
                        setDescription(event.target.value);
                    }}
                />


                <Autocomplete
                    multiple
                    id="tags-filled"
                    value={tags}
                    onChange={(event, newValue) => {
                        setTags(newValue.map((e) => e.toLowerCase()));
                    }}
                    options={tagsOptions}
                    freeSolo
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip variant="outlined" label={option} {...getTagProps({ index })} key={index} />
                        ))
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            onChange={(e) => {
                                fetchTagsOptions(e.target.value)
                            }}
                            label="Tags"
                            sx={{ background: "white" }}
                        />
                    )}
                />

                <Autocomplete
                    multiple
                    id="folders-filled"
                    value={folders}
                    onChange={(event, newValue) => {
                        setFolders(newValue.map((e) => e.toLowerCase()));
                    }}
                    options={foldersOptions}
                    freeSolo
                    renderTags={(value, getFoldersProps) =>
                        value.map((option, index) => (
                            <Chip variant="outlined" label={option} {...getFoldersProps({ index })} key={index} />
                        ))
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}

                            onChange={(e) => {
                                fetchFoldersOptions(e.target.value)
                            }}
                            label="Folders"
                            sx={{ background: "white" }}
                        />
                    )}
                />
            </Stack>

            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
            </Stack>

            <LoadingButton className={styles.updateButton} fullWidth size="large" type="submit" variant="contained" disabled={checkDisable()}
                loading={loading}
                onClick={submitUpdateDocument}
            >
                Update Document
            </LoadingButton>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Container >
    );
}

export default EditDocumentForm